import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import MetaData from "../../layout/MetaData";
import AdminLayout from "../../layout/AdminLayout";
import {useGetUserDetailsQuery, useUpdateUserMutation, } from "../../../redux/api/userApi";
import {useUploadCNICMutation} from "../../../redux/api/driverApi";

import "../../../css/Driver.css"

const EditDriverDetail = () => {

      const [driverVehicleNumber, setDriverVehicleNumber] = useState("");
      const [driverVehicleMakeModel, setDriverVehicleMakeModel] = useState("");
      const [driverVehicleCapacity, setDriverVehicleCapacity] = useState("");
      const [driverName, setDriverName] = useState("");
      // const [driverIDCardPic, setDriverIDCardPic] = useState("");

      const navigate = useNavigate();
      const params = useParams();
    
      const { data } = useGetUserDetailsQuery(params?.id);
    
      const [updateUser, {isLoading, error, isSuccess }] = useUpdateUserMutation();
      // const [uploadCNIC, {isLoading }] = useUploadCNICMutation()
      
        useEffect(() => {
          if (data?.user) {
            setDriverVehicleNumber(data?.user?.driverVehicleNumber);
            setDriverVehicleMakeModel(data?.user?.driverVehicleMakeModel)
            setDriverVehicleCapacity(data?.user?.driverVehicleCapacity)
            setDriverName(data?.user?.driverName)
            // setDriverIDCardPic(data?.user?.driverIDCardPic)
          }
        }, [data]);
      
        useEffect(() => {
          if (error) {
            toast.error(error?.data?.message);
          }
      
          if (isSuccess) {
            toast.success("Driver Updated");
            navigate("/admin/drivers");
          }
        }, [error, isSuccess]);
      
        // const onChange = (e) => {
        //     const reader = new FileReader();
          
        //     reader.onload = () => {
        //       if (reader.readyState === 2) {
        //         setDriverIDCardPic(reader.result); // Save the image data
        //       }
        //     };
          
        //     reader.readAsDataURL(e.target.files[0]);
        //   };
          
          const submitHandler = (e) => {
            e.preventDefault();
          
            const userData = {
              driverVehicleNumber,
              driverVehicleMakeModel,
              driverVehicleCapacity,
              driverName,
              // driverIDCardPic, // Include the picture in the payload
            };
          
            updateUser({ id: params?.id, body: userData });
          
            // If required, you can call uploadCNIC separately for only the image
            // uploadCNIC({ driverIDCardPic });
          };          

  return (
    <AdminLayout> 
      <MetaData title={"Update Driver"} />
      <div className="row wrapper">
        <div className="col-10 col-lg-8">
          <form className="shadow-lg" onSubmit={submitHandler}>
            <h2 className="mb-4">Update Driver Detail</h2>

            <div className="mb-3">
          <label htmlFor="name_field" className="form-label"> Enter Vehicle Number </label>
          <input
            type="text"
            id="name_field"
            className="form-control"
            name="name"
            value={driverVehicleNumber}
            onChange={(e) => setDriverVehicleNumber(e.target.value)}
          />
        </div>

        <div className="mb-3">
          <label htmlFor="name_field" className="form-label"> Enter Vehicle Make and Model </label>
          <input
            type="text"
            id="name_field"
            className="form-control"
            name="name"
            value={driverVehicleMakeModel}
            onChange={(e) => setDriverVehicleMakeModel(e.target.value)}
          />
        </div>

        <label htmlFor="name_field" className="form-label"> Enter Driver Vehicle Capacity </label>
        <div className="input-group">
          <span className="input-group-text">KG'S</span>
          <input
            type="Number"
            id="name_field"
            className="form-control"
            name="name"
            value={driverVehicleCapacity}
            onChange={(e) => setDriverVehicleCapacity(e.target.value)}
          />
        </div>
       
       <br></br>

        <div className="mb-3">
          <label htmlFor="name_field" className="form-label"> Enter Driver Name </label>
          <input
            type="Text"
            id="name_field"
            className="form-control"
            name="name"
            value={driverName}
            onChange={(e) => setDriverName(e.target.value)}
          />
        </div>

          {/* <div className="input-foam">
              <label className="form-label" htmlFor="customFile">
              Driver ID card
              </label>
              <input
                type="file"
                name="avatar"
                className="form-control"
                id="customFile"
                accept="images/*"
                onChange={onChange}
              />
            </div> */}

            <button type="submit" className="btn update-btn w-100 py-2" disabled={isLoading}>
              Update
            </button>
          </form>
        </div>
      </div>
    </AdminLayout>
  )
}

export default EditDriverDetail
